import * as React from 'react'
import { StyleSheet } from 'react-native'

import PlayerIcon from '../PlayerIcon'
import { View, Text } from '../../../components/Themed'

interface Props {
  positionTime: string
  durationTime: string
  isPlaying: boolean
  pause: () => void
  play: () => void
  replay: () => void
  forward: () => void
}
export default function PlayerControls({
  positionTime,
  durationTime,
  isPlaying,
  pause,
  play,
  replay,
  forward,
}: Props) {
  return (
    <View style={styles.container} >
      <View style={styles.controls}>
        <PlayerIcon name="replay-30" onPress={replay} size={42} />
        {isPlaying ? (
          <PlayerIcon name="pause-circle-filled" onPress={pause} />
        ) : (
          <PlayerIcon name="play-circle-filled" onPress={play} />
        )}
        <PlayerIcon name="forward-30" onPress={forward} size={42} />
      </View>
      <View style={styles.controls}>
        <Text style={styles.text}>{positionTime} / {durationTime}</Text>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    paddingLeft: 32,
    paddingRight: 32,
  },
  text: {
    paddingTop: 16,
  },
  controls: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
})
